// MA-874 (operator D-1101-23) — the pure `milestone_events` row -> MilestoneEvent mapper.
//
// Moved verbatim out of milestoneLogger.ts so a server bundle (the weekly
// recap's api/_lib/recapDetail.bundle.mjs) can map rows without pulling the
// browser supabase client, Sentry or the network circuit breaker.
// milestoneLogger imports it back and still exposes it as `__test.fromRow`; no
// behaviour change. Type-only imports (erased at build), nothing else.
import type { MilestoneEvent, MilestoneEventType, RewardType } from "./milestoneLogger";

// ── snake_case row → camelCase MilestoneEvent ────────────────────────

export function fromRow(r: Record<string, unknown>): MilestoneEvent {
  return {
    id: r.id as string,
    childId: r.child_id as string,
    eventType: r.event_type as MilestoneEventType,
    eventAt: r.event_at as string,
    sourceSkillIds: (r.source_skill_ids as string[]) ?? [],
    sourcePathId: (r.source_path_id as string | null) ?? null,
    rewardType: (r.reward_type as RewardType | null) ?? null,
    rewardVisibleToChild: (r.reward_visible_to_child as boolean) ?? false,
    rewardVisibleToParent: (r.reward_visible_to_parent as boolean) ?? true,
    contextData: (r.context_data as Record<string, unknown>) ?? {},
    // MA-14: undefined (not null) for pre-0015 legacy rows — mirrors the
    // audienceMode / evidenceContractVersion legacy-sentinel pattern.
    eventKey: (r.event_key ?? undefined) as string | undefined,
  };
}
